import { useTranslation, Trans } from "react-i18next";

import TradingViewWidget from './TradingViewWidget'

function Discover() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
           <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px] xl:max-w-[497px]">{t('home.37.1')}</p>
            <div className="mt-[20px] xl:mt-[40px]">
                <TradingViewWidget/>
            </div>
        </div>
    </div>
  );
}

export default Discover;
 